<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <div class="vx-row">
                    <!-- <h3 class="ml-2">Thông tin tài sản</h3> -->
                </div>
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('invoice.school') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="" v-model="branchModel" :clearable="false" :options="branchOptions"
                                  data-vv-validate-on="blur" :disabled="isUpdate" v-validate="'required'"
                                  name="school" @input="getData" :reduce="(option) => option.value">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('school') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.classRoom') }}</label>
                    <v-select class="" v-model="classRoomModel" @input="loadStudent()" :clearable="false"
                        :options="classRoomOptions" :disabled="isUpdate" >
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                </div>
            
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 mt-2 w-full">
                    <label class="vs-input--label">{{ $t('attendance.student') }}</label>
                    <span class="text-danger">*</span>
                    <v-select class="" v-model="selectedStudent" :reduce="(option) => option.value" v-validate="'required'"
                        :clearable="false" :options="studentOptions" :disabled="isUpdate" name="student">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('student') }}</span>
                </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('navMenu.leaveType') }}</label>
                        <v-select class="" v-model="leaveTypeModel" :clearable="false" :options="leaveTypeOptions"
                                  data-vv-validate-on="blur" :disabled="isUpdate" v-validate="'required'"
                                  name="leaveType">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('leaveType') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('menuOrganization.status') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="" v-model="leaveStatusModel" :clearable="false" :options="leaveStatusOptions.filter(el => el.value != leaveInfo.status)"
                                  data-vv-validate-on="blur" v-validate="'required'" name="leaveStatus">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('leaveStatus') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('textErr.fromDate') }}</label>
                        <span class="text-danger">*</span>
                        <datepicker :format="'dd/MM/yyyy'" v-model="leaveInfo.fromDate" @input="updateDetails" :highlighted="highlightedFn"
                                    data-vv-validate-on="input" :disabled="isUpdate" v-validate="'required'" name="fromDate">
                        </datepicker>
                        <span class="text-danger text-sm">{{ errors.first('fromDate') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('textErr.toDate') }}</label>
                        <span class="text-danger">*</span>
                        <datepicker :format="'dd/MM/yyyy'" v-model="leaveInfo.toDate" @input="updateDetails" :highlighted="highlightedFn"
                                    data-vv-validate-on="input" :disabled="isUpdate" v-validate="'required'" name="toDate">
                        </datepicker>
                        <span class="text-danger text-sm">{{ errors.first('toDate') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('menuCustomer.time') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="" v-model="durationModel" :clearable="false" :options="durationOptions"
                                  data-vv-validate-on="blur" :disabled="isUpdate" v-validate="'required'"
                                  name="duration">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('duration') }}</span>
                    </div>
                </div>

                <!-- <div v-if="leaveInfo.duration == 1" class="vx-row md:mb-1 mb-4" v-for="(item, indexItem) in leaveDetails" :key="indexItem">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('navMenu.leaveDate') }}</label>
                        <span class="text-danger">*</span>
                        <datepicker :format="'dd/MM/yyyy'" v-model="item.leaveDate"
                                    data-vv-validate-on="input" v-validate="'required'" name="leaveDate"
                                    disabled></datepicker>
                        <span class="text-danger text-sm">{{ errors.first('leaveDate') }}</span>
                    </div>
                    <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2 mt-2">
                        <label class="vs-input--label">{{ $t('textErr.workShiftName') }}</label>
                        <span class="text-danger">*</span>
                        <v-select :value="item.workshift" :disabled="isUpdate" :clearable="false"
                                  :options="item.workDayOfWeeks"
                                  @input="workshift => getWorkShiftName(item, workshift)"
                                  v-validate="'required'" :name="'Ca làm việc' + ' ' + (indexItem + 1)">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('Ca làm việc' + ' ' + (indexItem + 1)) }}</span>
                    </div>
                    <div class="vx-col lg:w-1/6 md:w-1/2 w-1/2 mt-2" v-if="item.workshift">
                        <label class="vs-input--label">{{ $t('textErr.time') }}</label>
                        <span class="text-danger">*</span>
                        <v-select :value="item.subWorkShiftDetail" :disabled="isUpdate" :clearable="false"
                                  :options="item.subWorkShifts"
                                   @input="subWorkShiftDetail => getWorkShiftDetail(item, subWorkShiftDetail)" v-validate="'required'" :name="'Thời gian' + ' ' + (indexItem + 1)">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('Thời gian' + ' ' + (indexItem + 1)) }}</span>
                    </div>
                </div> -->

                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full mt-5">
                        <vs-textarea class="w-full" :label="$t('textErr.reason')" v-model="leaveInfo.reason" :disabled="isUpdate"
                                     name="reason"/>
                        <span class="text-danger text-sm">{{ errors.first('reason') }}</span>
                    </div>
                    <div class="vx-col md:w-1/2 w-full mt-5">
                        <vs-textarea class="w-full" :label="$t('navMenu.comment')" v-model="leaveInfo.comment"
                                      name="comment"/>
                        <span class="text-danger text-sm">{{ errors.first('comment') }}</span>
                    </div>
                </div>

                <!-- Save & Reset Button -->
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
                            <vs-button class="ml-auto mt-2" @click="saveChanges"
                                       v-if="isPermissionUpdate()">{{
                                    `${isUpdate ?
                                        $t('button.update') : $t('button.create')}`
                                }}
                            </vs-button>
                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="leaveList" v-if="!leaveId">{{ $t('button.back') }}
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import utils from "../../../components/utils";
import moment from 'moment';
import { isAPI } from '../../../store/permission';
import { constAPI } from '../../../store/constant';

export default {
    components: {
        vSelect,
        Datepicker
    },
    props: {
        leaveId: {
            type: Number,
        },
        branchId: {
            type: Number,
        },
    },
    data() {
        return {
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledFn: {
                customPredictor(date) {
                    date  = new Date(date);
                    date.setDate(date.getDate());
                    if (moment(date).isBefore(moment(), 'days')) {
                        return true;
                    }
                }
            },
            user_data: null,
            branchModel:null,
            activeTab: 0,
            isUpdate: false,
            isUpdateFace: false,
            branchOptions: [],
            employeeOptions: [],
            leaveTypeOptions: [
                {value: 0, label: this.$t('navMenu.leavePermission')},
                {value: 1, label: this.$t('navMenu.unauthorizedAbsences')}
            ],
            leaveStatusOptions: [
                {value: 0, label: this.$t('statusActive.waiting')},
                {value: 1, label: this.$t('statusActive.approved')},
                {value: 2, label: this.$t('statusActive.decline')},
                // {value: 3, label: 'Hủy bỏ'}
            ],
            durationOptions: [
                {value: 0, label: this.$t('navMenu.allDay')},
                {value: 1, label: this.$t('navMenu.byShift')}
            ],
            classRoomModel: { value: null, label: this.$t('menuOrganization.all') },
            classRoomOptions: [],
            studentOptions:[],
            selectedStudent:null,
            leaveInfo: {},
            leaveDetails: [],
            workShiftSetting: [],
            timeSpans: [],
            workShifts:[],
            file: '',
            // fileName: 'Thêm dữ liệu khuôn mặt.',
            uploadPercent: 0,
            isShowPercent: false,
            isHoliday: false,
        }
    },
    created() {
       
       this.initScreen();
    },
    watch: {
        '$route.query.id'(value) {
            if (value) this.initScreen();
        }
    },
    computed: {
        leaveTypeModel: {
            get() {
                return {
                    label: this.getLabelString(this.leaveTypeOptions.find(x => x.value == this.leaveInfo.leaveType)),
                    value: this.leaveInfo.leaveType
                }
            },
            set(obj) {
                this.leaveInfo.leaveType = obj.value;
            }
        },
        leaveStatusModel: {
            get() {
                return {
                    label: this.getLabelString(this.leaveStatusOptions.find(x => x.value == this.leaveInfo.status)),
                    value: this.leaveInfo.status
                }
            },
            set(obj) {
                this.leaveInfo.status = obj.value;
            }
        },
        durationModel: {
            get() {
                return {
                    label: this.getLabelString(this.durationOptions.find(x => x.value == this.leaveInfo.duration)),
                    value: this.leaveInfo.duration
                }
            },
            set(obj) {
                this.leaveInfo.duration = obj.value;
            }
        },
        validateForm() {
            return !this.errors.any()
        },
    },
    methods: {
        async getData(){
            await this.getClassRoom()
            await this.loadStudent()
        },
        isPermissionUpdate() {
            return isAPI(this, constAPI.leave_edit)
        },
        getWorkShiftDetail(item, subWorkShiftName) {
            item.subWorkShiftDetail = item.subWorkShifts.find(el => el.workShiftDetailsId == subWorkShiftName.workShiftDetailsId);
            item.subWorkShiftName = subWorkShiftName.label;
            item.workShiftDetailsId = subWorkShiftName.workShiftDetailsId;
            item.workShiftId = subWorkShiftName.workShiftId;
            item.fromHour = subWorkShiftName.fromHour;
            item.toHour = subWorkShiftName.toHour;
        },
        getWorkShiftName(setting, workshift) {
            setting.workshift = this.workShifts.find(el => el.value == workshift.value);
            if (workshift.workShiftDetails && workshift.workShiftDetails.length > 0) {
                setting.subWorkShiftDetail = null
                setting.subWorkShifts = workshift.workShiftDetails.map(el => {
                    return {
                        label: el.subWorkShiftName,
                        workShiftId: el.workShiftId,
                        workShiftDetailsId: el.id,
                        fromHour: el.startHour,
                        toHour: el.endHour,
                    }
                })
                const fullday = {
                    label: 'Cả ngày',
                    workShiftId: workshift.value,
                    workShiftDetailsId: null,
                    fromHour: workshift.startHour,
                    toHour: workshift.endHour
                }
                setting.subWorkShifts.unshift(fullday);
            } else {
                setting.subWorkShifts = null;
                let object = this.workShifts.find(el => el.value == workshift.value);
                if (object) {
                    setting.fromHour = object.startHour;
                    setting.toHour = object.endHour;
                    setting.workShiftId = object.value;
                    setting.workShiftDetailsId = null;
                    setting.name = object.label;
                }
            }
        },
        getClassRoom() {
        return new Promise((resolve, reject) => {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            const payload = {
                organizationBranchId: this.branchModel,
                organizationId: userInfo.organization.id,
                status: true
            }
            this.$vs.loading()
            this.$crm.post('/school-classroom/get-all-class', payload).then((res) => {
                this.classRoomOptions = res.data.map(el => {
                    return {
                        label: el.className,
                        value: el.id
                    }
                });
                this.classRoomOptions.unshift({ label: 'Tất cả', value: null });
                resolve()
                this.$vs.loading.close()
            }).catch((err) => {
                reject()
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        })
    },
    loadStudent() {
        return new Promise((resolve, reject) => {
            this.$vs.loading();
            let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            let schoolStudentSearchDTO = {
                organizationBranchId: this.branchModel,
                organizationId: userInfo.organization.id,
                enabled: true,
                pageNumber: 1,
                pageSize: 1000,
                sort: 'id',
                classId: this.classRoomModel.value
            }
            this.$crm.post('/school-student/find-by-condition', schoolStudentSearchDTO).then((response) => {
                this.studentData = response.data.content;
                this.studentOptions = response.data.content.map(item => {
                    return {
                        value: item.id,
                        label: item.fullName,
                    }
                });
                this.studentOptions.unshift({ label: 'Tất cả', value: null });
                setTimeout(() => {
                    this.gridApi.sizeColumnsToFit();
                }, 180);
                resolve()
                this.$vs.loading.close();
            }).catch((err) => {
                reject()
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        })
    },
        findAllWorkShiftByIds: function () {
            this.$crm.post('/work-shift/employee/find-by-employee/' + this.leaveInfo.employeeId).then((response) => {
                this.workShifts = response.data.workShiftSettings.map(el => {
                    return {
                        label: el.name,
                        value: el.id,
                        workShiftDetails: el.workShiftDetails,
                        workDayOfWeek: el.workDayOfWeek,
                        endHour: el.endHour,
                        startHour: el.startHour,
                    }
                })
            }).catch((err) => {
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        async initScreen() {
            let timeDuration = 30, timeSpans = [];
            for (let i = 0; i < 24 * 60; i = i + timeDuration) {
                timeSpans.push({value: i, label: utils.minuteToHour(i)});
            }
            this.timeSpans = timeSpans;
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            this.branchOptions = branchList.filter(el => el.organizationBranchType === 3).map(x => {
                return {label: x.organizationBranchName, value: x.id}
            });
            this.leaveInfo = {
                leaveType: 0,
                status: 0,
                duration: 0,
            };
            await this.getClassRoom()
            await this.loadStudent()
            let leaveId = this.leaveId ? this.leaveId : this.$route.query.id;
            if (leaveId) {
                this.isUpdate = true;
                this.getDataInfo(leaveId)
                }
        },
        getDataInfo(leaveId) {
            this.$vs.loading();
            this.$crm.post('/leave/find-by-id/' + leaveId).then((response) => {
                this.$vs.loading.close();
                this.leaveInfo = response.data;
                this.branchModel = response.data.organizationBranchId;
                this.classRoomOptions.forEach(el => {
                    if(el.value === response.data.classId) this.classRoomModel = el.label
                })
                this.studentOptions.forEach(el => {
                    if(el.value === response.data.employeeId) this.selectedStudent = el.label
                })
                let result = response.data;
                this.leaveDetails = response.data.leaveDetails.map(item => {
                    let object = result.workShiftSettings.find(el => el.id == item.workShiftId);
                    if (object) {
                        item.workshift = {
                            label: object.name,
                            value: object.id
                        }

                        if (item.workShiftDetailsId) {
                            let subWorkShifts = object.workShiftDetails.find(el => el.id == item.workShiftDetailsId);
                            if (object.workShiftDetails && object.workShiftDetails.length > 0) {
                                item.subWorkShifts = object.workShiftDetails.filter(el => el.id == item.workShiftDetailsId);
                                item.subWorkShiftDetail = {
                                    label: subWorkShifts.subWorkShiftName,
                                    value: subWorkShifts.id
                                }
                            }
                        }

                        let fullday = !item.workShiftDetailsId && (object.startHour == item.fromHour) && (object.endHour == item.toHour);
                        if (fullday) {
                            item.subWorkShiftDetail = {
                                label: 'Cả ngày',
                                value: null
                            }
                        }
                    }
                    return item;
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuOrganization.null');
        },
        updateTimeSpan(setting, hour, type) {
            setting[type] = hour.value;
            setting[`${type}String`] = hour.label;
        },

        getHoliday(date){
            return new Promise((resolve, reject) => {
                let fromDate = new Date(date.setHours(0, 0, 0));
                let toDate = new Date(date.setHours(23, 59, 59));
                const payload = {
                    fromDate: fromDate,
                    toDate: toDate
                }
                this.$crm.post('/holiday/find-by-condition', payload).then((res) => {
                    if (res.data && res.data.length > 0) { resolve(true); this.isHoliday = true}
                    else resolve(false);
                }).catch((err) => {
                    reject(false);
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        async updateDetails() {
            if (this.isUpdate) return;
            let details = []
            if (!this.leaveInfo.fromDate || !this.leaveInfo.toDate) return;
            let fromDateObj = moment(this.leaveInfo.fromDate);
            let toDateObj = moment(this.leaveInfo.toDate);
            while (fromDateObj.format('YYYY-MM-DD') <= toDateObj.format('YYYY-MM-DD')) {
                let isHoliday = await this.getHoliday(new Date(fromDateObj));
                if (!isHoliday) {
                    details.push({
                        leaveDate: fromDateObj.format("YYYY-MM-DD"),
                        dayOfWeek: new Date(fromDateObj).getDay() === 0 ? 1 : new Date(fromDateObj).getDay() + 1,
                        fromHour: 0,
                        toHour: 0,
                        fromHourString: "00:00",
                        toHourString: "00:00",
                        workShiftId: null,
                        workShiftDetailsId: null,
                        workDayOfWeeks: [],
                    })
                }
                fromDateObj.add(1, 'd');
            }
            details.forEach(leave => {
                let arr = this.workShifts.filter(el => el.workDayOfWeek.includes(leave.dayOfWeek));
                leave.workDayOfWeeks = arr;
            })
            this.leaveDetails = details.filter(el => el.workDayOfWeeks.length > 0)
        },
        loadEmployee() {
            if (!this.leaveInfo.organizationBranchId) return;
            this.$vs.loading();
            this.$crm.post('/employee/find-by-organization-branch/' + this.leaveInfo.organizationBranchId).then((response) => {
                this.employeeData = response.data;
                this.$vs.loading.close();
                if (response.data.length == 0) {
                    this.employeeOptions = []
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: 'Không tồn tại nhân viên nào',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                this.employeeOptions = response.data.map(item => {
                    return {
                        value: item.employeeId,
                        label: item.employeeCode + " " + item.fullName
                    }
                });
                if (!this.isUpdate) this.employeeModel = this.employeeOptions[0]
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        async saveChanges(evt) {
            evt.preventDefault();
            try {
                if (!this.validateForm) return;

                const result = await this.$validator.validateAll();
                if (!result) return;

                // if (this.leaveDetails.length == 0) {
                //     return this.$vs.notify({
                //         text: 'Vui lòng không tạo đơn vào ngày không có lịch đi học!',
                //         iconPack: 'feather',
                //         icon: 'icon-alert-circle',
                //         color: 'danger'
                //     });
                // }

                let url = this.isUpdate ? `/leave/teacher-update/${this.leaveInfo.id}` : `/leave/assign-for-student/${this.branchModel}/${this.selectedStudent}`,
                    data = this.leaveInfo;
                    data.leaveDetails = this.leaveDetails
                     data.leaveDetails.push({
                        leaveDate: new Date(new Date().setDate(new Date().getDate() + 1)),
                        fromHour: 0,
                        toHour: 0,
                        fromHourString: "00:00",
                        toHourString: "00:00",
                        workShiftId: null,
                        workShiftDetailsId: null,
                        workDayOfWeeks: [],
                    })
                if (data.duration === 0 && this.isHoliday) {
                    return this.$vs.notify({
                        text: 'Khoảng thời gian đơn xin nghỉ nằm trong ngày nghỉ lễ!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                this.$vs.loading();
                this.$crm.post(url, data).then(() => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: 'success',
                        text: `${this.isUpdate ? this.$t('button.update') : this.$t('button.create')} đơn xin nghỉ thành công`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    if (this.leaveId) {
                        this.$eventBus.$emit("update-leave-success", {});
                    } else {
                        this.leaveList();
                    }
                }).catch((err) => {
                    this.$vs.loading.close();
                    if (this.leaveId) {
                        this.$eventBus.$emit("update-leave-success", {});
                    }
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } catch (ex) {
                console.log(ex);
            }
        },
        leaveList() {
            this.$router.push(`/user/application-for-leave`).catch(() => {
            })
        }
    },
}
</script>

<style scoped>

</style>
